export const createInventorySlice = (set, get) => ({
  inventoryItems: [],
  inventoryFilter: '',
  inventoryCurrentPage: 1,
  inventoryPageSize: 10,
  inventoryHasLoaded: false,
  inventoryLastFetched: null,
  inventoryIsLoading: false,

  setInventoryItems: (items) => set({ inventoryItems: items, inventoryCurrentPage: 1, inventoryHasLoaded: true, inventoryLastFetched: Date.now() }),
  setInventoryFilter: (filter) => set({ inventoryFilter: filter, inventoryCurrentPage: 1 }),
  setInventoryCurrentPage: (page) => set({ inventoryCurrentPage: page }),
  setInventoryPageSize: (size) => set({ inventoryPageSize: size, inventoryCurrentPage: 1 }),

  // Initialize inventory from API
  initializeInventory: async (fetchInventoryFn, forceRefresh = false) => {
    const state = get();
    // Return if already loading
    if (state.inventoryIsLoading) {
      return state.inventoryItems;
    }
    // Return cached if not forcing refresh and already loaded
    if (!forceRefresh && state.inventoryHasLoaded) {
      return state.inventoryItems;
    }
    
    try {
      set({ inventoryIsLoading: true });
      const response = await fetchInventoryFn();
      const items = response.inventory || [];
      set({ 
        inventoryItems: items,
        inventoryHasLoaded: true, 
        inventoryLastFetched: Date.now(),
        inventoryIsLoading: false 
      });
      return items;
    } catch (error) {
      set({ inventoryIsLoading: false });
      console.error('Error loading inventory:', error);
      throw error;
    }
  },

  getFilteredInventory: (state) => {
    if (!state.inventoryFilter) return state.inventoryItems;
    const query = state.inventoryFilter.toLowerCase();
    return state.inventoryItems.filter(
      (item) =>
        item.name.toLowerCase().includes(query) ||
        item.category.toLowerCase().includes(query)
    );
  },

  // Get paginated filtered inventory
  getPaginatedInventory: (state) => {
    const filtered = state.getFilteredInventory ? state.getFilteredInventory(state) : state.inventoryItems;
    const { inventoryCurrentPage, inventoryPageSize } = state;
    const startIndex = (inventoryCurrentPage - 1) * inventoryPageSize;
    const endIndex = startIndex + inventoryPageSize;
    
    return {
      data: filtered.slice(startIndex, endIndex),
      total: filtered.length,
      page: inventoryCurrentPage,
      pageSize: inventoryPageSize,
      pages: Math.ceil(filtered.length / inventoryPageSize)
    };
  },

  // Add inventory item to store
  addInventoryItem: (item) => set((state) => ({
    inventoryItems: [item, ...state.inventoryItems]
  })),

  // Update inventory item in store
  updateInventoryItem: (id, updatedItem) => set((state) => ({
    inventoryItems: state.inventoryItems.map(item => item.id === id ? updatedItem : item)
  })),

  // Remove inventory item from store
  removeInventoryItem: (id) => set((state) => ({
    inventoryItems: state.inventoryItems.filter(item => item.id !== id)
  }))
});
